import React from 'react';
import { Link } from "react-router-dom";
import { Drawer, Toolbar, List, ListItem, ListItemText} from '@mui/material';
import LogoutIcon from "@mui/icons-material/Logout";

export default function TopNav() {
  return (
    <Drawer variant="permanent" anchor="left">
      <Toolbar className='onClick' id='moneyBox'>

      </Toolbar>
      <div>
        <List>
          <ListItem button component={Link} to="/">
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button component={Link} to="/hustle">
            <ListItemText primary="Hustle!" />
          </ListItem>
          <ListItem button component={Link} to="/orders">
            <ListItemText primary="Orders" />
          </ListItem>
          <ListItem button component={Link} to="/reports">
            <ListItemText primary="Reports" />
          </ListItem>
          <ListItem button component={Link} to="/viewer">
            <ListItemText primary="Viewer" />
          </ListItem>
          <ListItem button component={Link} to="/settings">
            <ListItemText primary="Settings" />
          </ListItem>
          <ListItem button className='onClick' onClick={() => {
            localStorage.removeItem("authToken");
            window.location.href = "/login";
          }}>
            <LogoutIcon />
          </ListItem>
        </List>
      </div>
    </Drawer>
  );
}